import { IModalContentColumns } from "@sky-it-livedata/livedata-sports-design-system";

export const lgpHeaderModalContentData: IModalContentColumns = {
  title: "Vuoi vedere la diretta?",
  text: "Con l’abbonamento a NOW hai l’accesso diretto a tutte le dirette sportive.",
  imageSrc:
    "https://sport.sky.it/assets/images/55df4abdb6c2209c4a2d1d7c64c7dd9600ab47b4/skysport/configurations/shared/banner/NowTv_mosaico.png",
  imageAlt: "Guarda lo sport su NOW",
  ctaHref: "https://www.nowtv.it/sport?DCMP=interlinking_liveblog_SkySport",
  ctaText: "Guarda lo sport su NOW",
};

const navWrapper = 'j-section-nav-wrapper';
const localNav = 'c-local-nav';
const videoPlayerSticky = 's-hero-sticky-player-wrapper';

const zIndexClasses:string[] = [navWrapper, localNav, videoPlayerSticky];

let activeScrollLocks = 0;
let previousBodyOverflow = '';

const isBrowser = (): boolean => typeof window !== 'undefined' && typeof document !== 'undefined';

export const lockPageScroll = (): void => {
  if (!isBrowser()) {
    return;
  }

  activeScrollLocks += 1;
  if (activeScrollLocks > 1) {
    return;
  }

  const body = document.body;

  previousBodyOverflow = body.style.overflow;

  body.style.overflow = 'hidden';
};

export const unlockPageScroll = (): void => {
  if (!isBrowser()) {
    return;
  }
  if (activeScrollLocks === 0) {
    return;
  }

  activeScrollLocks -= 1;
  if (activeScrollLocks > 0) {
    return;
  }

  const body = document.body;

  body.style.overflow = previousBodyOverflow;
};

export const resetPageScrollLocks = (): void => {
  activeScrollLocks = 1;
  unlockPageScroll();
};

export const handleZindexes = (): void => {
  if (!isBrowser()) {
    return;
  }
  zIndexClasses.forEach(className => {
    const elements = document.querySelectorAll(`.${className}`) as NodeListOf<HTMLElement>;
    elements.forEach(element => {
      element.dataset.livedataModalOpen = 'true';
    });
  });
};

export const restoreZindexes = (): void => {
  if (!isBrowser()) {
    return;
  }

  zIndexClasses.forEach(className => {
    const elements = document.querySelectorAll(`.${className}`) as NodeListOf<HTMLElement>;
    elements.forEach(element => {
      element.dataset.livedataModalOpen = 'false';
    });
  });
};